export const scanTypeOptions = [
  { label: "Progressive", value: "PROGRESSIVE" },
  { label: "Interlaced", value: "INTERLACED" },
];

export const interlacedScanTypeOptions = [
  { label: "Top Field", value: "TOP_FIELD" },
  { label: "Bottom Field", value: "BOTTOM_FIELD" },
  { label: "Follow Top Field", value: "FOLLOW_TOP_FIELD" },
  { label: "Follow Bottom Field", value: "FOLLOW_BOTTOM_FIELD" },
];

export const fpsOptions = [
  { label: "Specified", value: "Specified" },
  { label: "Initialize from source", value: "INITIALIZE_FROM_SOURCE" },
];

export const channelModeOptions = [
  { label: "Mono (1.0)", value: "Mono (1.0)" },
  { label: "Stereo (2.0)", value: "Stereo (2.0)" },
  { label: "Surround (5.1)", value: "Surround (5.1)" },
];

export const audioSampleRateOptions = [
  { label: "44.1", value: "44.1" },
  { label: "48.0", value: "48.0" },
  { label: "88.2", value: "88.2" },
  { label: "96.0", value: "96.0" },
];

export const audioBitrateOptions = {
  44.1: [64, 80, 96, 112, 128, 160, 192, 224, 256, 288, 320, 384, 448, 512],
  "48.0": [64, 80, 96, 112, 128, 160, 192, 224, 256, 288, 320, 384, 448, 512, 576],
  88.2: [576],
  "96.0": [256, 288, 320, 384, 448, 512, 576],
};

export const videoFormatOptions = [
  { label: "MP4", value: "MP4" },
  { label: "MXF", value: "MXF" },
  { label: "WEBM", value: "WEBM" },
  { label: "MOV", value: "MOV" },
  { label: "TS", value: "TS" },
  { label: "HLS", value: "HLS" },
];

export const VIDEO_FORMAT_OPTIONS = {
  TS: "TS",
  MXF: "MXF",
  MP4: "MP4",
  WEBM: "WEBM",
  MOV: "MOV",
  HLS: "HLS",
};

export const videoCodecOptions = [
  { label: "H264", value: "H264" },
  { label: "XDCAM HD 50", value: "XDCAM HD 50" },
];

export const audioFormatOptions = {
  MP4: ["AAC"],
  MXF: ["Uncompressed WAV"],
  WebM: ["Opus", "Vorbis"],
  MOV: ["AAC"],
};

export const algorithmOptions = [
  { label: "ITU-R BS.1770-1", value: "ITU_BS_1770_1" },
  { label: "ITU-R BS.1770-2", value: "ITU_BS_1770_2" },
  { label: "ITU-R BS.1770-3", value: "ITU_BS_1770_3" },
  { label: "ITU-R BS.1770-4", value: "ITU_BS_1770_4" },
];

export const colorPrimaryOptions = [{ label: "BT.709", value: "BT.709" }];

export const bitrateTypeOptions = [
  { label: "CBR", value: "CBR" },
  { label: "VBR", value: "VBR" },
  { label: "QVBR", value: "QVBR" },
];

export const exportVideoDurationOptions = [
  { label: "Full Video", value: "fullMatchDownload" },
  { label: "Custom Duration", value: "partDownloadVideo" },
];

export const HLS_CONFIGURATION_OPTIONS = {
  SINGLE_BITRATE: "singleBitrate",
  MULTI_BITRATE: "multiBitrate",
};
export const hlsConfigurationRadioOptions = [
  { label: "Single-Bitrate", value: HLS_CONFIGURATION_OPTIONS.SINGLE_BITRATE },
  { label: "Multi-Bitrate", value: HLS_CONFIGURATION_OPTIONS.MULTI_BITRATE },
];
export const HLS_PRESET_VALUES = {
  FAST: "fast",
  MEDIUM: "medium",
  SLOW: "slow",
  SLOWER: "slower",
  VERY_SLOW: "veryslow",
};

export const hlsPresetOptions = [
  { label: "Fast (Fast VOD)", value: HLS_PRESET_VALUES.FAST },
  { label: "Medium (Standard VOD transcoding)", value: HLS_PRESET_VALUES.MEDIUM },
  { label: "Slow (High-quality VOD)", value: HLS_PRESET_VALUES.SLOW },
  { label: "Slower (Archival quality)", value: HLS_PRESET_VALUES.SLOWER },
  { label: "Very Slow (Premium VOD content)", value: HLS_PRESET_VALUES.VERY_SLOW },
];

export const JobsType = Object.freeze({
  FULL_MATCH_EXPORT: "downloadVideo",
  PART_MATCH_EXPORT: "partDownloadVideo",
  MERGE_AND_EXPORT: "mergeAndExport",
});
